import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Link = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement(SvgFill, {
    d: "M31.44 21.23c-2.935-2.933-7.547-3.204-10.784-.799a.94.94 0 1 1-1.12-1.507c3.974-2.954 9.63-2.623 13.231.979a10.159 10.159 0 0 1 0 14.375l-7.162 7.162a10.16 10.16 0 0 1-14.375 0 10.158 10.158 0 0 1-1.571-12.349.939.939 0 1 1 1.616.957 8.28 8.28 0 0 0 1.283 10.064 8.28 8.28 0 0 0 11.72 0l7.161-7.162a8.28 8.28 0 0 0 0-11.72Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M31.44 4.728a8.28 8.28 0 0 0-11.72 0l-7.162 7.162a8.28 8.28 0 0 0 0 11.719c2.934 2.934 7.546 3.205 10.784.8a.94.94 0 0 1 1.12 1.507c-3.975 2.953-9.63 2.623-13.232-.979a10.159 10.159 0 0 1 0-14.375L18.392 3.4a10.159 10.159 0 0 1 14.375 0 10.158 10.158 0 0 1 1.572 12.349.939.939 0 1 1-1.616-.957 8.28 8.28 0 0 0-1.284-10.064Z"
  })));
});
Link.displayName = 'Link';
Link.defaultProps = {
  'aria-label': 'Link'
};
export default Link;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Link.js
// module id = 3199
// module chunks = 11